module.exports = __webpack_public_path__ + "img/zaiJiaTryv3.c20dc127.png";